import { User } from "lucide-react"

/**
 * Composant Avatar réutilisable avec support pour avatar par défaut avec initiales
 */
export default function Avatar({ 
  src, 
  name, 
  size = 40, 
  className = "",
  showFallback = true 
}) {
  // Fonction pour générer les initiales de l'utilisateur
  const getUserInitials = (name) => {
    if (!name) return "U"
    const parts = name.trim().split(" ")
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    }
    return name.substring(0, 2).toUpperCase()
  }

  // Fonction pour obtenir la couleur de l'avatar par défaut basée sur le nom
  const getAvatarColor = (name) => {
    if (!name) return "bg-blue-500"
    const colors = [
      "bg-blue-500",
      "bg-green-500",
      "bg-purple-500",
      "bg-pink-500",
      "bg-indigo-500",
      "bg-yellow-500",
      "bg-red-500",
      "bg-teal-500"
    ]
    const index = name.charCodeAt(0) % colors.length
    return colors[index]
  }

  const sizeClasses = {
    12: { container: "w-12 h-12", text: "text-lg", icon: "w-6 h-6" },
    16: { container: "w-16 h-16", text: "text-xl", icon: "w-8 h-8" },
    20: { container: "w-20 h-20", text: "text-2xl", icon: "w-10 h-10" },
    24: { container: "w-24 h-24", text: "text-3xl", icon: "w-12 h-12" },
    32: { container: "w-32 h-32", text: "text-4xl", icon: "w-16 h-16" },
    40: { container: "w-10 h-10", text: "text-sm", icon: "w-5 h-5" },
    48: { container: "w-12 h-12", text: "text-lg", icon: "w-6 h-6" }
  }

  const sizeConfig = sizeClasses[size] || { container: "w-10 h-10", text: "text-sm", icon: "w-5 h-5" }

  return (
    <div className={`relative ${sizeConfig.container} ${className}`}>
      {src ? (
        <>
          <img 
            src={src} 
            alt={name || "Avatar"} 
            className={`${sizeConfig.container} rounded-full object-cover border-2 border-gray-200`}
            onError={(e) => {
              // Si l'image ne charge pas, afficher l'avatar par défaut
              e.target.style.display = 'none'
              const parent = e.target.parentElement
              const defaultAvatar = parent.querySelector('.default-avatar')
              if (defaultAvatar) {
                defaultAvatar.style.display = 'flex'
              }
            }}
          />
          {showFallback && (
            <div 
              className={`default-avatar ${sizeConfig.container} ${getAvatarColor(name)} rounded-full flex items-center justify-center border-2 border-gray-200 hidden`}
            >
              <span className={`text-white font-semibold ${sizeConfig.text}`}>
                {getUserInitials(name)}
              </span>
            </div>
          )}
        </>
      ) : (
        <div className={`${sizeConfig.container} ${getAvatarColor(name)} rounded-full flex items-center justify-center border-2 border-gray-200`}>
          {name ? (
            <span className={`text-white font-semibold ${sizeConfig.text}`}>
              {getUserInitials(name)}
            </span>
          ) : (
            <User className={`${sizeConfig.icon} text-white`} />
          )}
        </div>
      )}
    </div>
  )
}
